import React, { useEffect, useMemo, useState } from "react";
import axios from "../../utils/axiosConfig";
import { useNavigate, useParams } from "react-router-dom";
import DealNavigation from "../../components/DealNavigation";
import BuyerDetailModal from "../../components/BuyerDetailModal";
import ShipperDetailModal from "../../components/ShipperDetailModal"; 
import FollowupModal from "../../components/FollowupModal";  
import FixationModal from "../../components/FixationModal";
import DealInfoPanel from "../../components/DealInfoPanel";
import { buildFixationPricingDefaults } from "../../utils/fixationDefaults";
const ContainerRelease = () => {
    const { dealId } = useParams();
    const navigate = useNavigate();

    const [deal, setDeal] = useState(null);
    const [containers, setContainers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showDealInfo, setShowDealInfo] = useState(true);
    const [showBuyer, setShowBuyer] = useState(false);
    const [showShipper, setShowShipper] = useState(false);
    const [showFollowup, setShowFollowup] = useState(false);
    const [showFixation, setShowFixation] = useState(false);
    const fixationPricingDefaults = useMemo(() => buildFixationPricingDefaults(deal), [deal]);
    const vesselGroups = useMemo(() => {
        const groups = new Map();
        containers.forEach((row, index) => {
            // Containers are grouped by Vessel Name + BL No; a different BL on the
            // same vessel gets its own group.
            const vesselName = row.VesselName?.trim() || "(No Vessel Assigned)";
            const blNo = String(row.BLNo || "").trim();
            const key = `${vesselName.toLocaleUpperCase()}|${blNo.toLocaleUpperCase()}`;
            if (!groups.has(key)) {
                groups.set(key, { key, vesselName, blNo, entries: [] });
            }
            groups.get(key).entries.push({ row, index });
        });
        return Array.from(groups.values());
    }, [containers]);

    useEffect(() => {
        if (dealId) {
            fetchData();
        }
    }, [dealId]);

    const fetchData = async () => {
        setLoading(true);
        try {
            const dealRes = await axios.get(`/container-release/deal/${dealId}`);
            const containerRes = await axios.get(`/container-release/${dealId}`);

            setDeal(dealRes.data);
            setContainers(containerRes.data);

        } catch (err) {
            console.error(err);
            alert(err.response?.data?.message || "Error loading data");
        }
        setLoading(false);
    };

    const handleChange = (index, field, value) => {
        const updated = [...containers];
        updated[index][field] = value;
        setContainers(updated);
    };

    const handleSave = async (row) => {

        if (!row.ArrivalDate) {
            alert("Arrival Date is required");
            return;
        }

        try {

            await axios.put(`/container-release/${row.ShipmentID}`, {
                ShipmentID: row.ShipmentID,
                DealID: dealId,
                ArrivalDate: row.ArrivalDate,
                PaymentDate: row.PaymentDate,
                Amount: row.Amount,
                ReferenceNo: row.ReferenceNo
            });

            alert("Container release updated successfully");
            fetchData();

        } catch (err) {

            if (err.response?.status === 401) {
                alert("Your login session is invalid or expired. Please login again.");
                navigate("/login");
                return;
            }

            alert(err.response?.data?.message || "Error saving");

        }

    };
    if (!dealId) return <div>Invalid Deal ID</div>;
    if (loading) return <div>Loading...</div>;
    if (!deal) return <div>No deal found</div>;
    return (
        <>
            <DealNavigation
                dealId={dealId}
                openBuyer={() => setShowBuyer(true)}
                openShipper={() => setShowShipper(true)}
                openFixation={() => setShowFixation(true)}
                openFollowup={() => setShowFollowup(true)}
            />


            <div className="container-fluid mt-3">

                <div className="mb-2">
                     <span className="badge bg-success fs-6 px-3 py-2">
                    Container Release
                    </span>
                </div>

                {/* DEAL INFORMATION */}

                <DealInfoPanel
                    deal={deal}
                    show={showDealInfo}
                    onToggle={() => setShowDealInfo(!showDealInfo)}
                />

                <div className="card shadow-sm mb-4 d-none">
                    <div className="card-header bg-light">
                        <h5 className="mb-0">Deal Information</h5>
                    </div>

                    <div className="card-body">

                        <div className="row g-3 mb-2">

                            <div className="col-md-4">
                                <label className="form-label fw-semibold">Deal No - Date</label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    value={`${deal.DealID} - ${deal.DealDate?.split("T")[0]}`}
                                    disabled
                                />
                            </div>

                            <div className="col-md-4">
                                <label className="form-label fw-semibold">Status</label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    value={deal.Status || "DOC RELEASE"}
                                    disabled
                                />
                            </div>

                            <div className="col-md-4">
                                <label className="form-label fw-semibold">S.C No - Date</label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    value={
                                        deal.SCRNo
                                            ? `${deal.SCRNo}${deal.SCRDate ? ` - ${deal.SCRDate.split("T")[0]}` : ""}`
                                            : ""
                                    }
                                    disabled
                                />
                            </div>

                        </div>

                        <div className="row g-3 mb-2">

                            <div className="col-md-6">
                                <label className="form-label fw-semibold">Buyer Name</label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    value={deal.BuyerName || ""}
                                    disabled
                                />
                            </div>

                            <div className="col-md-6">
                                <label className="form-label fw-semibold">Shipper Name</label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    value={deal.ShipperName || ""}
                                    disabled
                                />
                            </div>

                        </div>

                    </div>
                </div>


                {/* CONTAINER TABLE */}

                <div className="card shadow-sm">

                    <div className="card-header bg-light">
                        <h5 className="mb-0">Container Released</h5>
                    </div>

                    <div className="card-body p-0">

                        <div className="table-responsive">

                            <table className="table table-bordered table-hover table-sm mb-0">

                                <thead className="table-light">

                                    <tr className="text-center">
                                        <th>Invoice No</th>
                                        <th>BL No</th>
                                        <th>BL Date</th>
                                        <th>Container</th>
                                        <th>Total Qty</th>
                                        <th>Arrival Date *</th>
                                        <th>Payment Date</th>
                                        <th>Balance Amount</th>
                                        <th>Reference</th>
                                        <th>Action</th>
                                    </tr>

                                </thead>

                                <tbody>

                                    {containers.length === 0 ? (

                                        <tr>
                                            <td colSpan="10" className="text-center text-muted">
                                                No container records found
                                            </td>
                                        </tr>

                                    ) : (

                                        vesselGroups.map((group) => (
                                            <React.Fragment key={group.key}>
                                                <tr className="table-secondary">
                                                    <th scope="rowgroup" colSpan="10" className="fw-semibold text-start">
                                                        Vessel: {group.vesselName} | BL No: {group.blNo || "(No BL)"} ({group.entries.length} container{group.entries.length > 1 ? "s" : ""})
                                                    </th>
                                                </tr>
                                                {group.entries.map(({ row, index }) => (
                                            <tr key={row.ShipmentID} className="align-middle text-center">

                                                <td>{row.InvoiceNo || "-"}</td>
                                                <td>{row.BLNo}</td>
                                                <td>{row.BLDate?.split("T")[0]}</td>
                                                <td>{row.ContainerNo}</td>
                                                <td>{row.TotalQty}</td>

                                                <td>
                                                    <input
                                                        type="date"
                                                        className="form-control form-control-sm"
                                                        value={row.ArrivalDate?.split("T")[0] || ""}
                                                        disabled={row.IsCopyDocReceived === 0}
                                                        onChange={(e) =>
                                                            handleChange(index, "ArrivalDate", e.target.value)
                                                        }
                                                    />
                                                </td>

                                                <td>
                                                    <input
                                                        type="date"
                                                        className="form-control form-control-sm"
                                                        value={row.PaymentDate?.split("T")[0] || ""}
                                                        onChange={(e) =>
                                                            handleChange(index, "PaymentDate", e.target.value)
                                                        }
                                                    />
                                                </td>

                                                <td>
                                                    <input
                                                        type="number"
                                                        className="form-control form-control-sm text-end"
                                                        value={row.Amount ?? ""}
                                                        placeholder="Balance unavailable"
                                                        readOnly
                                                    />
                                                </td>

                                                <td>
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        value={row.ReferenceNo || ""}
                                                        onChange={(e) =>
                                                            handleChange(index, "ReferenceNo", e.target.value)
                                                        }
                                                    />
                                                </td>

                                                <td>
                                                    <button
                                                        className="btn btn-primary btn-sm"
                                                        disabled={row.IsCopyDocReceived === 0}
                                                        onClick={() => handleSave(row)}
                                                    >
                                                        Save
                                                    </button>
                                                </td>

                                            </tr>

                                                ))}
                                                <tr className="table-light fw-bold">
                                                    <th scope="row" colSpan="7" className="text-start">Total</th>
                                                    <td className="text-end">
                                                        {group.entries.reduce((total, { row }) => total + (Number(row.Amount) || 0), 0).toFixed(2)}
                                                    </td>
                                                    <td colSpan="2"></td>
                                                </tr>
                                            </React.Fragment>
                                        ))

                                    )}

                                </tbody>

                            </table>

                        </div>

                    </div>

                </div>

            </div>


            {/* BUYER MODAL */}

            <BuyerDetailModal
                show={showBuyer}
                dealId={dealId}
                onClose={() => setShowBuyer(false)}
            />
            <ShipperDetailModal
                show={showShipper}
                dealId={dealId}
                onClose={() => setShowShipper(false)}
            />
            <FixationModal
                show={showFixation}
                dealId={dealId}
                totalQty={deal.TotalQty}
                dealCurrency={deal.DealCurrency}
                dealPricingDefaults={fixationPricingDefaults}
                onClose={() => setShowFixation(false)}
            />
            <FollowupModal
                show={showFollowup}
                dealId={dealId}
                onClose={() => setShowFollowup(false)}
            />
        </>
    );
};

export default ContainerRelease;
